import styled from "@emotion/styled";
import { Modal as MuiModal } from "@mui/material";
import type * as React from "react";

type Props = {
  readonly onClose: () => void;
  readonly open: boolean;
  readonly disableBackdropClose?: boolean;
  readonly "aria-labelledby"?: string;
};

const StyledModal = styled(MuiModal)`
  display: grid;
  justify-content: center;
  align-items: center;

  & > div {
    &:first-of-type {
      background-color: rgba(0, 0, 0, 0.25) !important;
    }
  }
`;

const StyledBody = styled.div`
  outline: none;
`;

export const Modal: React.FunctionComponent<React.PropsWithChildren<Props>> = (props) => {
  const handleClose = (_event: object, reason: "backdropClick" | "escapeKeyDown") => {
    if (props.disableBackdropClose && reason === "backdropClick") return;
    props.onClose();
  };

  return (
    <StyledModal open={props.open} onClose={handleClose}>
      {/* biome-ignore lint/a11y/useSemanticElements: MUI Modal (role="presentation") already handles portal, focus trap and backdrop; dialog semantics go on the focused body like MUI Dialog's Paper */}
      <StyledBody role="dialog" aria-modal="true" aria-labelledby={props["aria-labelledby"]}>
        {props.children}
      </StyledBody>
    </StyledModal>
  );
};
